import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';


import * as cartActions from '../cartActions';

import cartService from '../../../../services/CartService';


function CartProvider({children}) {

    const [areCartsLoaded, setAreCartsLoaded] = useState(false);
    const dispatch = useDispatch();

    // Provider loads carts once during bootstrap
    useEffect(() => {

        (async () => {

            const activeCart = await cartService.getActiveCart();
            dispatch(cartActions.onCartsLoaded([activeCart]));

            setAreCartsLoaded(true);
        })();
    }, []);

    if (!areCartsLoaded) {

        return null;
    }

    return children;
}


CartProvider.propTypes = {
    children: PropTypes.any
};

CartProvider.defaultProps = {};


export default CartProvider;
